// Variables CSS de la refonte, partagées par les thèmes admin et utilisateur.
export const designTokens = `
    --ds-cambridge-dark: #4f8479;
    --ds-cambridge-tint: #E3EFEC;
    --ds-pear-ink: #6b7500;
    --ds-pear-tint: #F2F7C8;
    --ds-error-ink: #b21414;
    --ds-error-tint: #FCE8E8;
    --ds-neutral-tint: #EFEDE4;
    --ds-column-bg: #F3F1E3;
    --ds-row-divider: #F4F2EA;
    --ds-row-hover: #FCFBF4;
    --ds-chart-muted: #A39D97;
    --ds-surface: #FFFFFF;
    --ds-radius-xs: 6px;
    --ds-radius-sm: 8px;
    --ds-radius-md: 10px;
    --ds-radius-lg: 12px;
    --ds-radius-xl: 16px;
    --ds-radius-pill: 999px;
    --ds-shadow-card: 0 1px 2px rgba(63, 63, 63, 0.06);
    --ds-shadow-card-hover: 0 6px 16px rgba(63, 63, 63, 0.1);
    --ds-shadow-popover: 0 12px 40px rgba(63, 63, 63, 0.18);
    --ds-ease: ease;
    --ds-dur-fast: 150ms;
`;
